import React from 'react';
import Navigation from '../components/Navigation';
import './Inventory.css';


const Inventory = () => {

  const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';

  return (
    <div 
    style={{
        position:"fixed",
        top:0,
        width:"100%"
      }}

    >
      <div className="inventoryContent">
      <Navigation></Navigation>
        
        <iframe
            style={{
              marginTop: '20px',
              height: '100vh',
                width: '100%',
                zoom: '0.75',
              }}
            title="inventory-frame"
            src={`https://${subdomain}-taiga.shadowstream.world/project/${subdomain}-tasks/kanban?tags=inventory`}
        >
        </iframe>

      </div>
    </div>
  );
};

export default Inventory;
